{
  "list": [
    {
      "policyNumber": "6700710745",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": null,
      "dateBegin": "2023-01-01T00:00:00.000+01:00",
      "dateEnd": "2022-12-28T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 0,
      "tariff": "1OB",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710744",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": null,
      "dateBegin": "2023-01-01T00:00:00.000+01:00",
      "dateEnd": "2022-12-28T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 0,
      "tariff": "1OB",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710747",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 5,
      "dateBegin": "2023-01-01T00:00:00.000+01:00",
      "dateEnd": "2023-01-10T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 50,
      "tariff": "2OB",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710746",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 5,
      "dateBegin": "2023-01-01T00:00:00.000+01:00",
      "dateEnd": "2023-01-10T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 50,
      "tariff": "2OB",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710748",
      "scheme": "r\u00e1mcov\u00e9 zmluvy - BB",
      "rate": 2.9,
      "dateBegin": "2022-12-25T00:00:00.000+01:00",
      "dateEnd": "2022-12-28T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 11.6,
      "tariff": "2BB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710750",
      "scheme": "r\u00e1mcov\u00e9 zmluvy - BB",
      "rate": 2.9,
      "dateBegin": "2022-12-25T00:00:00.000+01:00",
      "dateEnd": "2022-12-28T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 11.6,
      "tariff": "2BB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710743",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 5,
      "dateBegin": "2022-12-25T00:00:00.000+01:00",
      "dateEnd": "2022-12-26T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 10,
      "tariff": "2OB",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710742",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 5,
      "dateBegin": "2022-12-25T00:00:00.000+01:00",
      "dateEnd": "2022-12-26T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 10,
      "tariff": "2OB",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710749",
      "scheme": "r\u00e1mcov\u00e9 zmluvy - BB",
      "rate": 2.9,
      "dateBegin": "2022-12-25T00:00:00.000+01:00",
      "dateEnd": "2022-12-25T00:00:00.000+01:00",
      "statusId": 5,
      "statusLabel": "stornovan\u00e1",
      "premium": 11.6,
      "tariff": "2BB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710741",
      "scheme": "r\u00e1mcov\u00e9 zmluvy - BB",
      "rate": 2.9,
      "dateBegin": "2022-12-23T00:00:00.000+01:00",
      "dateEnd": "2022-12-31T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 26.1,
      "tariff": "2BB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710722",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2022-12-23T00:00:00.000+01:00",
      "dateEnd": "2022-12-23T00:00:00.000+01:00",
      "statusId": 5,
      "statusLabel": "stornovan\u00e1",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710738",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2022-12-22T00:00:00.000+01:00",
      "dateEnd": "2022-12-22T00:00:00.000+01:00",
      "statusId": 5,
      "statusLabel": "stornovan\u00e1",
      "premium": 9.9,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710737",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2022-12-22T00:00:00.000+01:00",
      "dateEnd": "2022-12-24T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 3.3,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710724",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2022-12-22T00:00:00.000+01:00",
      "dateEnd": "2022-12-22T00:00:00.000+01:00",
      "statusId": 5,
      "statusLabel": "stornovan\u00e1",
      "premium": 2.2,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710723",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2022-12-22T00:00:00.000+01:00",
      "dateEnd": "2022-12-22T00:00:00.000+01:00",
      "statusId": 5,
      "statusLabel": "stornovan\u00e1",
      "premium": 2.2,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710735",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2022-12-22T00:00:00.000+01:00",
      "dateEnd": "2022-12-22T00:00:00.000+01:00",
      "statusId": 5,
      "statusLabel": "stornovan\u00e1",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710739",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2022-12-22T00:00:00.000+01:00",
      "dateEnd": "2022-12-28T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 7.7,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710734",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2022-12-21T00:00:00.000+01:00",
      "dateEnd": "2022-12-22T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 2.2,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710726",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2022-12-21T00:00:00.000+01:00",
      "dateEnd": "2022-12-21T00:00:00.000+01:00",
      "statusId": 5,
      "statusLabel": "stornovan\u00e1",
      "premium": 11,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700710700",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2022-12-16T00:00:00.000+01:00",
      "dateEnd": "2022-12-16T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 1.1,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700000053",
      "scheme": "LN_ramcove zmluvy",
      "rate": 1.1,
      "dateBegin": "2022-12-14T00:00:00.000+01:00",
      "dateEnd": "2022-12-20T00:00:00.000+01:00",
      "statusId": 4,
      "statusLabel": "akt\u00edvna",
      "premium": 7.7,
      "tariff": "1LN1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700413575",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2018-02-22T00:00:00.000+01:00",
      "dateEnd": "2018-02-24T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 62.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700406843",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2018-02-05T00:00:00.000+01:00",
      "dateEnd": "2018-02-06T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 20.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700390625",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2017-11-14T00:00:00.000+01:00",
      "dateEnd": "2017-11-16T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700390617",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2017-11-14T00:00:00.000+01:00",
      "dateEnd": "2017-11-16T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 23.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700341305",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2017-05-17T00:00:00.000+02:00",
      "dateEnd": "2017-05-19T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700341297",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2017-05-17T00:00:00.000+02:00",
      "dateEnd": "2017-05-19T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700293324",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2016-10-25T00:00:00.000+02:00",
      "dateEnd": "2016-10-28T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700293332",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2016-10-25T00:00:00.000+02:00",
      "dateEnd": "2016-10-28T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 20.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700275008",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2016-09-13T00:00:00.000+02:00",
      "dateEnd": "2016-09-15T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700275016",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2016-09-13T00:00:00.000+02:00",
      "dateEnd": "2016-09-15T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 15.6,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700257279",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2016-06-07T00:00:00.000+02:00",
      "dateEnd": "2016-06-08T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700257287",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2016-06-07T00:00:00.000+02:00",
      "dateEnd": "2016-06-08T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700221044",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2016-02-08T00:00:00.000+01:00",
      "dateEnd": "2016-02-12T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 13,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700221051",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2016-02-08T00:00:00.000+01:00",
      "dateEnd": "2016-02-10T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700217695",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2016-01-20T00:00:00.000+01:00",
      "dateEnd": "2016-01-21T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700217190",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2016-01-17T00:00:00.000+01:00",
      "dateEnd": "2016-01-20T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700217182",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2016-01-17T00:00:00.000+01:00",
      "dateEnd": "2016-01-22T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 15.6,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700183244",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2015-08-23T00:00:00.000+02:00",
      "dateEnd": "2015-08-25T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700162602",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2015-05-18T00:00:00.000+02:00",
      "dateEnd": "2015-05-21T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700143271",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2015-02-12T00:00:00.000+01:00",
      "dateEnd": "2015-02-14T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 46.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700141465",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2015-02-10T00:00:00.000+01:00",
      "dateEnd": "2015-02-11T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700141457",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2015-02-01T00:00:00.000+01:00",
      "dateEnd": "2015-02-02T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700140335",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2015-01-26T00:00:00.000+01:00",
      "dateEnd": "2015-01-27T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700138776",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2015-01-13T00:00:00.000+01:00",
      "dateEnd": "2015-01-14T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700137745",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2015-01-07T00:00:00.000+01:00",
      "dateEnd": "2015-01-08T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700132209",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2014-11-23T00:00:00.000+01:00",
      "dateEnd": "2014-11-26T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700128173",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2014-10-26T00:00:00.000+02:00",
      "dateEnd": "2014-10-28T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700119057",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2014-09-04T00:00:00.000+02:00",
      "dateEnd": "2014-09-05T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700118604",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 3.3,
      "dateBegin": "2014-09-02T00:00:00.000+02:00",
      "dateEnd": "2014-09-02T00:00:00.000+02:00",
      "statusId": 5,
      "statusLabel": "stornovan\u00e1",
      "premium": 13.2,
      "tariff": "1OB",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700118612",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2014-09-02T00:00:00.000+02:00",
      "dateEnd": "2014-09-03T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700117770",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2014-08-25T00:00:00.000+02:00",
      "dateEnd": "2014-08-25T00:00:00.000+02:00",
      "statusId": 5,
      "statusLabel": "stornovan\u00e1",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700117788",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2014-08-25T00:00:00.000+02:00",
      "dateEnd": "2014-08-28T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 20.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700108100",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2014-05-29T00:00:00.000+02:00",
      "dateEnd": "2014-05-29T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 36.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700095513",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2014-02-27T00:00:00.000+01:00",
      "dateEnd": "2014-02-28T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700095505",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2014-02-17T00:00:00.000+01:00",
      "dateEnd": "2014-02-18T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700089284",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-12-09T00:00:00.000+01:00",
      "dateEnd": "2013-12-12T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 20.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700089755",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-12-09T00:00:00.000+01:00",
      "dateEnd": "2013-12-12T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700089748",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-12-06T00:00:00.000+01:00",
      "dateEnd": "2013-12-06T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 2.6,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700089276",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-12-06T00:00:00.000+01:00",
      "dateEnd": "2013-12-06T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 46.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700085670",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-11-11T00:00:00.000+01:00",
      "dateEnd": "2013-11-14T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700084434",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-11-04T00:00:00.000+01:00",
      "dateEnd": "2013-11-07T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 20.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700076885",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-09-13T00:00:00.000+02:00",
      "dateEnd": "2013-09-17T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 13,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700070011",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-06-23T00:00:00.000+02:00",
      "dateEnd": "2013-07-04T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 31.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700069393",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-06-18T00:00:00.000+02:00",
      "dateEnd": "2013-06-21T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700068106",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-06-10T00:00:00.000+02:00",
      "dateEnd": "2013-06-11T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700067884",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-06-10T00:00:00.000+02:00",
      "dateEnd": "2013-06-12T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700067678",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-06-06T00:00:00.000+02:00",
      "dateEnd": "2013-06-07T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700063438",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-05-09T00:00:00.000+02:00",
      "dateEnd": "2013-05-10T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700058198",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-03-19T00:00:00.000+01:00",
      "dateEnd": "2013-03-20T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 20.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700057000",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-03-07T00:00:00.000+01:00",
      "dateEnd": "2013-03-08T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700054502",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-02-15T00:00:00.000+01:00",
      "dateEnd": "2013-02-16T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 62.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700054494",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-02-11T00:00:00.000+01:00",
      "dateEnd": "2013-02-15T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 26,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700052761",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2013-01-21T00:00:00.000+01:00",
      "dateEnd": "2013-01-23T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700050542",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-12-11T00:00:00.000+01:00",
      "dateEnd": "2012-12-14T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 20.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700045583",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-10-30T00:00:00.000+01:00",
      "dateEnd": "2012-11-03T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 26,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700043380",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-10-29T00:00:00.000+01:00",
      "dateEnd": "2012-10-31T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700039248",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-09-13T00:00:00.000+02:00",
      "dateEnd": "2012-09-13T00:00:00.000+02:00",
      "statusId": 5,
      "statusLabel": "stornovan\u00e1",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700039529",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-09-12T00:00:00.000+02:00",
      "dateEnd": "2012-09-14T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 15.6,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700039255",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-09-12T00:00:00.000+02:00",
      "dateEnd": "2012-09-13T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 5.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700038067",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 4,
      "dateBegin": "2012-09-02T00:00:00.000+02:00",
      "dateEnd": "2012-09-10T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 72,
      "tariff": "2SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700038117",
      "scheme": "r\u00e1mcov\u00e9 zmluvy - BB",
      "rate": 1.5,
      "dateBegin": "2012-09-02T00:00:00.000+02:00",
      "dateEnd": "2012-09-02T00:00:00.000+02:00",
      "statusId": 5,
      "statusLabel": "stornovan\u00e1",
      "premium": 90,
      "tariff": "1B1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700038125",
      "scheme": "r\u00e1mcov\u00e9 zmluvy - BB",
      "rate": 1.5,
      "dateBegin": "2012-09-01T00:00:00.000+02:00",
      "dateEnd": "2012-09-30T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 45,
      "tariff": "1B1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700032847",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-06-18T00:00:00.000+02:00",
      "dateEnd": "2012-06-20T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 15.6,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700032573",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-06-18T00:00:00.000+02:00",
      "dateEnd": "2012-06-22T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 13,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700027136",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-04-24T00:00:00.000+02:00",
      "dateEnd": "2012-04-26T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700025049",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-03-26T00:00:00.000+02:00",
      "dateEnd": "2012-03-28T00:00:00.000+02:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6700024331",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-03-12T00:00:00.000+01:00",
      "dateEnd": "2012-03-14T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 23.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6632483175",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-03-04T00:00:00.000+01:00",
      "dateEnd": "2012-03-08T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 26,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6632483167",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-02-28T00:00:00.000+01:00",
      "dateEnd": "2012-03-01T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 7.8,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6632483134",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-02-17T00:00:00.000+01:00",
      "dateEnd": "2012-02-19T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 23.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6632483159",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-02-17T00:00:00.000+01:00",
      "dateEnd": "2012-02-18T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 31.2,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    },
    {
      "policyNumber": "6632483126",
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "rate": 2.6,
      "dateBegin": "2012-02-16T00:00:00.000+01:00",
      "dateEnd": "2012-02-19T00:00:00.000+01:00",
      "statusId": 12,
      "statusLabel": "koniec platnosti",
      "premium": 10.4,
      "tariff": "1SB1",
      "groupPolicyNumber": "6690029258"
    }
  ],
  "allDataFlag": true
}
